import type { SentryConfig } from '@/contexts/dynamic-config';

export interface SentryTracingRuntimeConfig {
  enabled: boolean;
  sampleRate: number;
}

export const DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG: SentryTracingRuntimeConfig =
  {
    enabled: true,
    sampleRate: 0.01,
  };

let _config = DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG;

export const sentryTracingRuntimeConfig = {
  get: (): SentryTracingRuntimeConfig => _config,
  reset: () => {
    _config = DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG;
  },
  set: (config: SentryTracingRuntimeConfig) => {
    _config = config;
  },
};

const normalizeSampleRate = (sampleRate?: number | null) => {
  if (
    typeof sampleRate !== 'number' ||
    Number.isNaN(sampleRate) ||
    sampleRate < 0 ||
    sampleRate > 1
  ) {
    return DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG.sampleRate;
  }

  return sampleRate;
};

export const resolveSentryTracingRuntimeConfig = (
  config?: SentryConfig | null,
): SentryTracingRuntimeConfig => ({
  enabled:
    Boolean(
      config?.tracing?.enabled ?? DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG.enabled,
    ) &&
    Boolean(
      config?.tracing?.restaurant_app?.enabled ??
        DEFAULT_SENTRY_TRACING_RUNTIME_CONFIG.enabled,
    ),
  sampleRate: normalizeSampleRate(config?.tracing?.restaurant_app?.sample_rate),
});
